import React, { Component, ReactNode } from 'react';
import Icon from '../../../icons/Icon';
import { RootState } from '../../../redux/store';
import { changeChart, changeChartEditorOptions } from '../../../redux/actions/ChartActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { ChartState } from '../../../redux/reducers/ChartReducer';
import ValueFactory from '../../../util/ValueFactory';
import { AxisItem, MetricItem, SegmentItemTabs } from '../../../domain/chart/ChartDomains';
import { customConfirm } from '../../custom/CustomPopupConfirm';
import ChartValueFactory from '../../../util/ChartValueFactory';
import { generateColorPalette, generateMixedColorPalette } from 'components/custom/color-palette/ColorPaletteFactory';
import { ChartType } from '@trlogic/ui-pack';
import LanguageUtil from '../../../util/LanguageUtil';

class AxisTab extends Component<Props> {
  render() {
    const {
      chart: { chart },
    } = this.props;
    const { type } = chart;
    return (
      <div className={'flex flex-col w-full px-5 py-5  gap-x-5 gap-y-5 overflow-y-scroll h-full lg:max-h-[calc(100vh-360px)]'}>
        {this.getGlobalFilterAxis()}
        {type != ChartType.INDICATOR && this.getSegmentAxisItems()}
        {this.getMetricAxisItem()}
        {/*{type != ChartType.INDICATOR && this.getBreakdownAxis()}*/}
      </div>
    );
  }

  private getMetricItem = (): ReactNode => {
    const {
      chart: { chart, chartEditorOptions },
    } = this.props;
    return chartEditorOptions.metricItem?.map((item: MetricItem, index) => {
      const linearBorder =
        chart.type == ChartType.PIE || chart.type == ChartType.DONUT
          ? ``
          : `linear-gradient(to right, ${item.metric?.appearance?.colorSettings?.activeColor || 'black'} ) 0 0 4 / auto 1`;
      return (
        <div
          key={'horizontalAxis' + index}
          style={{
            borderImage: linearBorder,
          }}
          className={'w-full flex rounded-[2px] gap-x-2 items-center border-[1px] border-[#E0E4E8] px-2 py-2'}
        >
          {chart.type == ChartType.PIE || chart.type == ChartType.DONUT ? null : chartEditorOptions.breakdown == null ? (
            <div className={'w-4 h-4 rounded-[2px]'} style={{ backgroundColor: item.metric.appearance.colorSettings.activeColor }}></div>
          ) : null}
          <p onClick={() => this.toggleMetricEditor(item)} className={'text-f-purple cursor-pointer flex w-full truncate'}>
            {item.name}
          </p>
          <span className={'ml-auto'} onClick={(e) => this.removeMetricItem(item.name, e)}>
            <Icon icon={'close'} size={14} className={'ml-auto cursor-pointer text-primary'} />
          </span>
        </div>
      );
    });
  };

  private getGlobalFilterItem = (): ReactNode => {
    const {
      chart: { chartEditorOptions },
    } = this.props;
    if (chartEditorOptions.globalFilterItem == null) return;
    return (
      <div key={'globalFilter'} className={'w-full flex rounded-[2px] items-center border-[1px] border-[#E0E4E8] px-2 py-2'}>
        <p onClick={() => this.toggleGlobalFilterEditor()} className={'text-f-purple cursor-pointer'}>
          {chartEditorOptions.globalFilterItem?.label}
        </p>
        <span className={'ml-auto'} onClick={(e) => this.removeGlobalFilterItem(e)}>
          <Icon icon={'close'} size={14} className={'ml-auto cursor-pointer text-primary'} />
        </span>
      </div>
    );
  };

  private getBreakdownItem = (): ReactNode => {
    const {
      chart: { chartEditorOptions },
    } = this.props;
    let linearBorder = '';
    if (chartEditorOptions.breakdown != null) {
      linearBorder = `linear-gradient(to right, ${chartEditorOptions?.breakdown?.colorPalette?.[0] || 'white'}, white) 0 0 4 / auto 1`;
    } else {
      return;
    }

    return (
      <div className={'w-full flex rounded-[2px] items-center  border-[1px] border-red-500 '}>
        <div
          key={'breakdown'}
          style={{
            borderImage: linearBorder,
          }}
          className={'w-full flex rounded-[2px] items-center px-2 py-2'}
        >
          <p onClick={() => this.toggleBreakdownEditor()} className={'text-f-purple cursor-pointer'}>
            {chartEditorOptions.breakdown?.name}
          </p>
          <span className={'ml-auto'} onClick={(e) => this.removeBreakdownItem(e)}>
            <Icon icon={'close'} size={14} className={'ml-auto cursor-pointer text-primary'} />
          </span>
        </div>
      </div>
    );
  };

  private getSegmentItems = (): ReactNode => {
    const {
      chart: { chartEditorOptions, chart },
    } = this.props;

    if (chartEditorOptions.segmentItem == null) return;
    const linearBorder =
      chart.type == ChartType.PIE || chart.type == ChartType.DONUT
        ? `linear-gradient(to right, #84C9B3,#C56565,#A488CB,#DBA9C7,#EDD981,#CDC1A2,#E9A669,#B98171,#EE8769) 0 0 4 / auto 1`
        : '';

    return (
      <div className={'flex w-full h-full border-[1px] rounded-[2px]'}>
        <div
          style={{
            borderImage: linearBorder,
          }}
          className={'w-full flex  items-center'}
        >
          <div key={'verticalAxis'} className={'w-full flex rounded-[2px] items-center px-2 py-2'}>
            <p onClick={() => this.toggleSegmentEditor()} className={'text-f-purple  cursor-pointer'}>
              {chartEditorOptions.segmentItem.name}
            </p>
            <span onClick={(e: any) => this.removeSegmentItem(e)} className={'ml-auto'}>
              <Icon icon={'close'} size={14} className={'ml-auto cursor-pointer text-primary'} />
            </span>
          </div>
        </div>
      </div>
    );
  };

  private getGlobalFilterAxis = (): ReactNode => {
    const {
      chart: { chart, chartEditorOptions },
    } = this.props;
    return (
      <div className={'flex flex-col w-full rounded bg-white gap-x-3 gap-y-3 '}>
        <div className={'flex w-full items-between justify-between'}>
          <span className={'flex items-center gap-x-2'}>
            <Icon icon={'filter'} className={'text-primary'} size={18} />
            <p className={'text-primary text-[13px] font-medium'}>{LanguageUtil.get({ id: 'common.label.filter', defaultMessage: 'Filter' })}</p>
          </span>
          <p className={'self-end text-[#828282] text-xs'}>{LanguageUtil.get({ id: 'common.label.optional', defaultMessage: 'Optional' })}</p>
        </div>
        {this.getGlobalFilterItem()}
        {!chartEditorOptions.globalFilterItem && (
          <a
            onClick={() => this.addGlobalFilterItem()}
            className={'flex items-start px-3 py-2 rounded w-full bg-white border-[1px] border-f-purple text-f-purple cursor-pointer'}
          >
            {LanguageUtil.get({ id: 'common.label.addFilter', defaultMessage: '+ Add Filter' })}
          </a>
        )}
      </div>
    );
  };

  /*private getBreakdownAxis = (): ReactNode => {
    const {chart: {chart, chartEditorOptions}} = this.props;
    if (chart.type == ChartType.DONUT || chart.type == ChartType.PIE) return;
    return (
      <div className={"flex flex-col w-full rounded border-[1px] border-f-black-5 bg-white px-3 py-3 gap-x-3 gap-y-3 "}>
        <div className={"flex w-full items-between justify-between"}>
                        <span className={"flex items-center gap-x-2"}>
                        <Icon icon={"horizontal"} size={18}/>
                        <p className={"text-primary text-[13px] font-medium"}>Breakdown</p>
                        </span>
          <p className={"self-end text-[#828282] text-xs"}>Optional</p>
        </div>
        {this.getBreakdownItem()}
        {
          !chartEditorOptions.breakdown &&
         <a onClick={() => this.addBreakdownItem()}
            className={"flex items-start px-3 py-2 rounded w-full bg-white border-[1px] border-f-purple text-f-purple cursor-pointer"}> +
          Add Breakdown</a>
        }
      </div>)
  }*/

  private getMetricAxisItem = (): ReactNode => {
    const {
      chart: { chart, chartEditorOptions },
    } = this.props;
    return (
      <div className={'flex flex-col w-full rounded bg-white gap-x-3 gap-y-3'}>
        <div className={'flex w-full items-between justify-between'}>
          <span className={'flex items-center gap-x-2'}>
            <Icon icon={'horizontal'} size={18} />
            <p className={'text-primary text-[13px] font-medium'}>{LanguageUtil.get({ id: 'common.label.metric', defaultMessage: 'Metric' })}</p>
          </span>
        </div>
        {this.getMetricItem()}
        <a
          onClick={this.addMetricItem}
          className={'flex items-start px-3 py-2 rounded w-full bg-white border-[1px] border-f-purple text-f-purple cursor-pointer'}
        >
          +{LanguageUtil.get({ id: 'common.label.addNewMetric', defaultMessage: 'Add New Metric' })}
        </a>
      </div>
    );
  };

  private getSegmentAxisItems = (): ReactNode => {
    const {
      chart: { chartEditorOptions },
    } = this.props;
    return (
      <div className={'flex flex-col w-full rounded bg-white gap-x-3 gap-y-3 '}>
        <div className={'flex w-full items-between justify-between'}>
          <span className={'flex items-center gap-x-2'}>
            <Icon icon={'vertical'} size={18} />
            <p className={'text-primary text-[13px] font-medium'}>{LanguageUtil.get({ id: 'common.label.segment', defaultMessage: 'Segment' })}</p>
          </span>
        </div>
        {this.getSegmentItems()}
        {chartEditorOptions.segmentItem == undefined && (
          <a
            onClick={this.addSegmentItem}
            className={'flex items-start px-3 py-2 rounded w-full bg-white border-[1px] border-f-purple text-f-purple cursor-pointer'}
          >
            +{LanguageUtil.get({ id: 'common.label.addSegment', defaultMessage: 'Add Segment' })}
          </a>
        )}
      </div>
    );
  };

  private addMetricItem = () => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    if (chartEditorOptions.metricItem == undefined) chartEditorOptions.metricItem = [];
    chartEditorOptions.metricItem.push({
      name: LanguageUtil.get(
        {
          id: 'common.label.countOfRecord',
          defaultMessage: `Count of Record${chartEditorOptions.metricItem.length > 0 ? '-' + chartEditorOptions.metricItem.length : ''}`,
        },
        { 0: `${chartEditorOptions.metricItem.length > 0 ? '-' + chartEditorOptions.metricItem.length : ''}` },
      ),
      metric: ChartValueFactory.initializeMetric(chartEditorOptions?.metricItem?.length),
    });
    changeChartEditorOptions(chartEditorOptions);
    this.toggleMetricEditor(chartEditorOptions.metricItem[chartEditorOptions.metricItem.length - 1]);
  };

  private addSegmentItem = () => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    chartEditorOptions.segmentEditorVisible = !chartEditorOptions.segmentEditorVisible;
    chartEditorOptions.segmentItem = {
      name: LanguageUtil.get({ id: 'common.label.groupBySegment', defaultMessage: 'Group By Segment' }),
      activeTab: SegmentItemTabs.GROUP_BY,
      colorPalette: generateMixedColorPalette('#3498db', 'white', 10),
      segments: {
        dateHistogram: ChartValueFactory.initializeDateHistogramSegment(),
        groupBy: ChartValueFactory.initializeGroupBySegment(),
        filter: ChartValueFactory.initializeFilterSegment(),
        clustering: ChartValueFactory.initializeClusterSegment(),
      },
    };
    changeChartEditorOptions(chartEditorOptions);
  };

  private addGlobalFilterItem = () => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    chartEditorOptions.globalFilterItem = {
      label: LanguageUtil.get({ id: 'common.label.globalFilter', defaultMessage: 'Global Filter' }),
      syntax: ValueFactory.initializeExpression(),
    };
    changeChartEditorOptions(chartEditorOptions);
    this.toggleGlobalFilterEditor();
  };

  private addBreakdownItem = () => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    chartEditorOptions.breakdown = {
      name: LanguageUtil.get({ id: 'common.label.name', defaultMessage: 'Name' }),
      activeTab: SegmentItemTabs.GROUP_BY,
      colorPalette: generateColorPalette('#284564', 10),
      segments: {
        dateHistogram: ChartValueFactory.initializeDateHistogramSegment(),
        groupBy: ChartValueFactory.initializeGroupBySegment(),
        filter: ChartValueFactory.initializeFilterSegment(),
        clustering: ChartValueFactory.initializeClusterSegment(),
      },
    };

    changeChartEditorOptions(chartEditorOptions);
    this.toggleBreakdownEditor();
  };

  private removeMetricItem = (name: string, e: any) => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    customConfirm({
      target: e.currentTarget,
      message: LanguageUtil.get({ id: 'messages.confirm.removeMetricItem', defaultMessage: 'Are you sure remove this metric item?' }),
      accept() {
        chartEditorOptions.metricItem = chartEditorOptions.metricItem.filter((item: AxisItem) => item.name != name);
        changeChartEditorOptions(chartEditorOptions);
      },
    });
  };

  private removeGlobalFilterItem = (e: any) => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    customConfirm({
      target: e.currentTarget,
      message: LanguageUtil.get({ id: 'messages.confirm.deleteGlobalFilter', defaultMessage: 'Do you want to delete global filter item?' }),
      accept() {
        chartEditorOptions.globalFilterItem = null;
        changeChartEditorOptions(chartEditorOptions);
      },
    });
  };

  private removeBreakdownItem = (e: any) => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    customConfirm({
      target: e.currentTarget,
      message: LanguageUtil.get({ id: 'messages.confirm.deleteBreakdownItem', defaultMessage: 'Do you want to delete breakdown item?' }),
      accept() {
        chartEditorOptions.breakdown = null;
        changeChartEditorOptions(chartEditorOptions);
      },
    });
  };
  private removeSegmentItem = (e: any) => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    customConfirm({
      target: e.currentTarget,
      message: LanguageUtil.get({ id: 'messages.confirm.deleteSegmentItem', defaultMessage: 'Do you want to delete segment item?' }),
      accept() {
        chartEditorOptions.segmentItem = null;
        changeChartEditorOptions(chartEditorOptions);
      },
    });
  };
  private toggleSegmentEditor = () => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    chartEditorOptions.segmentEditorVisible = !chartEditorOptions.segmentEditorVisible;
    changeChartEditorOptions(chartEditorOptions);
  };
  private toggleBreakdownEditor = () => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    chartEditorOptions.breakdownEditorVisible = !chartEditorOptions.breakdownEditorVisible;
    changeChartEditorOptions(chartEditorOptions);
  };

  private toggleGlobalFilterEditor = () => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    chartEditorOptions.globalFilterEditorVisible = !chartEditorOptions.globalFilterEditorVisible;
    changeChartEditorOptions(chartEditorOptions);
  };

  private toggleMetricEditor = (axisItem: MetricItem) => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    chartEditorOptions.activeMetricItem = axisItem as MetricItem;
    chartEditorOptions.metricEditorVisible = !chartEditorOptions.metricEditorVisible;
    changeChartEditorOptions(chartEditorOptions);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  chart: state.chart as ChartState,
});

const mapDispatchToProps = { changeChart, changeChartEditorOptions };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(AxisTab);
